export default {
      id: "ic_info-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#ic_info-usage",
      toString: function () {
        return this.url;
      }
    }